import type { App } from 'vue';
import LineTitle from '../components/layout/LineTitle.vue';

//UI
import BaseButton from '../components/UI/BaseButton.vue';
import BaseIcon from '../components/UI/BaseIcon.vue';
import BaseTitle from '../components/layout/BaseTitle.vue';
import BaseAlert from '../components/UI/BaseAlert.vue';
import BaseBackBtn from '@/components/UI/BaseBackBtn.vue';
import PageWrapper from '@/components/layout/PageWrapper.vue';

//form
import BaseCheckbox from '../components/form/BaseCheckbox.vue';
import BaseInput from '../components/form/BaseInput.vue';
import MultiSelect from '../components/form/MultiSelect.vue';
import BaseTextArea from '../components/form/BaseTextArea.vue';
import BaseRadio from '../components/form/BaseRadio.vue';

export default (app: App) => {
  app.component('LineTitle', LineTitle);
  app.component('BaseInput', BaseInput);
  app.component('BaseCheckbox', BaseCheckbox);
  app.component('BaseButton', BaseButton);
  app.component('BaseIcon', BaseIcon);
  app.component('MultiSelect', MultiSelect);
  app.component('BaseTitle', BaseTitle);
  app.component('BaseAlert', BaseAlert);
  app.component('BaseTextArea', BaseTextArea);
  app.component('BaseRadio', BaseRadio);
  app.component('BaseBackBtn', BaseBackBtn);
  app.component('PageWrapper', PageWrapper);
};
